import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { createTheme } from "@mui/material/styles";


import PaddedContentArea from "../../common/PaddedContentArea";
import HomeCalendar from "./Components/HomeCalendar";
import YourDayBanner from "./Components/YourDayBanner";
import ActivityTrackerV3 from "./Components/ActivityTrackerV3";
import ChallengeTrackerV2 from "./Components/ChallengeTrackerV2";
import WorkoutHistory from "./Components/WorkoutHistory";

import {
    CheckRequirementsAndRedirectV2, GetAllWorkOutHistories, GetWorkOutHistory,
    GetAllWorkOutHistoriesWithArchived, GetSelectionHistory, LoadAccountDetails
} from "../../redux/v2/user/actions";
import { GetPrograms, GetSuggestedPrograms2 } from "../../redux/v2/program/actions";
import { GetChallenges } from "../../redux/v2/challenge/actions";
import { ScreenType } from "../../utils/breakpoints";

import useWorkoutPlan from "../../hooks/useWorkoutPlan";
import useDate from "../../hooks/useDate";

import "./style.css";
import { ErrorBoundary } from "react-error-boundary";

function Fallback({ error, resetErrorBoundary }) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.
    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre style={{ color: "red" }}>{error.message}</pre>
        </div>
    );
}

function Home(props) {
    return (
        <ErrorBoundary
            FallbackComponent={Fallback}
            onReset={(details) => {
                // Reset the state of your app so the error doesn't happen again
            }}
        >
            <HomeContent {...props} />
        </ErrorBoundary>
    )
}

function HomeContent(props) {
    const { GetCalendarMatrixV2 } = useDate();
    const navigate = useNavigate();
    const theme = createTheme({
        breakpoints: {
            values: {
                desktop: 1025,
            },
        },
    });
    const isDesktop = useMediaQuery(theme.breakpoints.up("desktop"));
    const screenSize = ScreenType(useMediaQuery);
    const { account } = props.User;
    const { programs } = props.Program;
    const { workoutPlan } = useWorkoutPlan({ account, programs });

    const [weekProgress, setWeekProgress] = useState(0);
    const [selectedDate, setSelectedDate] = useState(null);
    const [pointDate, setPointDate] = useState(null);

    const calendar = GetCalendarMatrixV2(workoutPlan ? workoutPlan?.schedule : {}, pointDate);
    const onboardingDetail = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];

    useEffect(() => {
        if (account?.user?.id) {
            props.CheckRequirementsAndRedirectV2(navigate);
            props.GetWorkOutHistory();
            props.GetAllWorkOutHistories();
            props.GetAllWorkOutHistoriesWithArchived();
            props.GetSelectionHistory();
            props.GetChallenges("active");
            props.GetPrograms();
            props.GetSuggestedPrograms2();
        } else {
            props.LoadAccountDetails();
        }
    }, [account?.user?.id]);

    useEffect(() => {
        if (onboardingDetail?.created_at) {
            setPointDate(onboardingDetail?.created_at);
        }

    }, [onboardingDetail?.created_at]);

    return (
        <div id="home">

            <div className="row">
                <div className={`col-md-${isDesktop ? "6" : "12"} home-left`}>
                    <HomeCalendar workoutPlan={workoutPlan} calendar={calendar} setSelectedDate={setSelectedDate} isDesktop={isDesktop} />
                    <YourDayBanner workoutPlan={workoutPlan} selectedDate={selectedDate} calendar={calendar} />
                </div>
                <div className={`col-md-${isDesktop ? "6" : "12"} home-right`}>
                    <PaddedContentArea>
                        <ActivityTrackerV3
                            screenSize={screenSize}
                            setWeekProgress={(count) => {
                                if (count == 0) {
                                    setWeekProgress(0);
                                } else if (count > 0 && count < 3) {
                                    setWeekProgress(1);
                                } else {
                                    setWeekProgress(2);
                                }
                            }}
                        />

                        <ChallengeTrackerV2 />
                    </PaddedContentArea>
                </div>
                <div className="col-md-12 home-bottom">
                    <PaddedContentArea>
                        <WorkoutHistory screenSize={screenSize} />
                    </PaddedContentArea>
                </div>
                {/* {account.aaa.ddd} */}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Program: state.Program,
});

export default connect(mapStateToProps, {
    CheckRequirementsAndRedirectV2,
    GetPrograms,
    GetWorkOutHistory,
    GetAllWorkOutHistories,
    GetAllWorkOutHistoriesWithArchived,
    GetSelectionHistory,
    GetChallenges,
    LoadAccountDetails,
    GetSuggestedPrograms2,
})(HomeContent);